<template>
  <b-form-invalid-feedback v-if="message" :id="id" :force-show="forceShow">
    <div class="d-flex mb-1 mt-1" :class="classesCSS">
      <div class="cercleErreur" :class="'cercleErreur-' + messageType">
        <span
          class="cercleErreur-contenu graphik_bold"
          :class="'cercleErreur-contenu-' + messageType"
          >!</span
        >
      </div>
      <div
        class="d-flex message-invalide ml-1"
        :class="'message-invalide-' + messageType"
        v-html="messageErreur"
      ></div>
    </div>
  </b-form-invalid-feedback>
</template>

<script>
import mixinMessageErreur from '@/mixins/mixinMessageErreur';

export default {
  name: 'ErreurValidation',
  mixins: [mixinMessageErreur],
  props: {
    id: { type: String, default: null },
    message: { type: String, default: null },
    keys: { type: Object, default: null },
    variables: { type: Object, default: null },
    classesCSS: { type: String, default: null },
    forceShow: { type: Boolean, default: false },
  },
  data() {
    return {
      messageErreur: null,
      messageType: 'erreur',
    };
  },
  watch: {
    message: {
      handler() {
        // Cette mixin écrit dans this.messageErreur et this.messageType
        this.mixinMessageErreur_getMessage(this.message, this.keys, null, this.variables);
      },
      // force eager callback execution
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.cercleErreur-info {
  background-color: #ffd45e;
}
.cercleErreur-contenu-info {
  color: black;
}
.message-invalide-info {
  color: black;
}
</style>
